var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __export = (target, all) => {
  __markAsModule(target);
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __reExport = (target, module2, desc) => {
  if (module2 && typeof module2 === "object" || typeof module2 === "function") {
    for (let key of __getOwnPropNames(module2))
      if (!__hasOwnProp.call(target, key) && key !== "default")
        __defProp(target, key, { get: () => module2[key], enumerable: !(desc = __getOwnPropDesc(module2, key)) || desc.enumerable });
  }
  return target;
};
var __toModule = (module2) => {
  return __reExport(__markAsModule(__defProp(module2 != null ? __create(__getProtoOf(module2)) : {}, "default", module2 && module2.__esModule && "default" in module2 ? { get: () => module2.default, enumerable: true } : { value: module2, enumerable: true })), module2);
};
__export(exports, {
  SCALAR_FUNCTIONS: () => SCALAR_FUNCTIONS,
  SCALAR_FUNCTION_TRANSLATE: () => SCALAR_FUNCTION_TRANSLATE,
  default: () => scalar_default
});
var import_mathFunctionError = __toModule(require("../../../../../error/mathFunctionError"));
var import_math = __toModule(require("../helper/math"));
var import_utils = __toModule(require("../helper/utils"));
const SCALAR_FUNCTION_TRANSLATE = {
  "CALCULA DIAS": "dateCalculateDays",
  "CALCULA GRAVAMEN": "calculateGravamen",
  "CALCULA GRAVAMEN REDONDEO": "calculateGravamenRound",
  "CALCULA GRAVAMEN MX": "calculateGravamenRoundInteger",
  "CAMBIAR FECHA": "dateReverse",
  "CONSTRUIR TEXTO MATRIZ": "buildMatrixText",
  CONCATENAR: "concatenate",
  "CORTAR APELLIDOS": "parseName",
  "DERECHA NUMERO": "rightNumber",
  DERECHA: "rightNumber",
  "DERECHA TEXTO": "rightText",
  "ELIGE NUMERO MATRIZ": "elementMatrixNumber",
  "ELIGE TEXTO MATRIZ": "elementMatrixText",
  "FECHA XML": "dateHumanize",
  "IZQUIERDA NUMERO": "leftNumber",
  "IZQUIERDA TEXTO": "leftText",
  IZQUIERDA: "leftNumber",
  MAXIMO: "maximum",
  MINIMO: "minimum",
  "MAYOR OCURRENCIA MATRIZ": "mode",
  "NO VAC\xCDO": "notEmpty",
  PORCENTAJE: "percentage",
  REDONDEA: "round",
  "REDONDEA ENTERO": "roundInteger",
  SANITIZAR: "sanitize",
  "SUMA ELEMENTOS MATRIZ": "summatoryMatrix",
  "TRUNCAR ENTERO": "floor",
  VAC\u00CDO: "empty"
};
const SCALAR_FUNCTIONS = Object.values(SCALAR_FUNCTION_TRANSLATE);
const calculateBaseGravamen = (args, math, scope, roundType, truncateRange, roundGravamen) => {
  const [x, y, z] = (0, import_utils.evalArgs)(args, scope, import_utils.ARG.SCALAR.STRING, import_utils.ARG.MATRIX.STRING);
  const taxBase = parseFloat(x || 0);
  if (Number.isNaN(taxBase)) {
    throw new import_mathFunctionError.MathFunctionError(`Function calculateGravamen. X is not a number '${x}'`);
  }
  const range = y.split(",").map((value) => {
    const rangeValue = parseFloat(value);
    if (Number.isNaN(rangeValue)) {
      throw new import_mathFunctionError.MathFunctionError(`Function calculateGravamen. Y element is not a number '${value}'`);
    }
    return rangeValue;
  });
  const taxForRange = z.split(",").map((value) => {
    const taxForRangeValue = parseFloat(value) / 100;
    if (Number.isNaN(taxForRangeValue)) {
      throw new import_mathFunctionError.MathFunctionError(`Function calculateGravamen. Z element is not a number '${value}'`);
    }
    return taxForRangeValue;
  });
  if (range.length !== taxForRange.length) {
    throw new import_mathFunctionError.MathFunctionError(`Function calculateGravamen. Different array lengths: Y = ${range.length}, Z = ${taxForRange.length}`);
  }
  return (0, import_math.calculateGravamenFunction)(math, taxBase, range, taxForRange, roundType, truncateRange, roundGravamen);
};
const calculateGravamen = (args, math, scope) => {
  return calculateBaseGravamen(args, math, scope, import_math.roundFunction);
};
calculateGravamen.rawArgs = true;
const calculateGravamenRound = (args, math, scope) => {
  return calculateBaseGravamen(args, math, scope, import_math.roundFunction, false, true);
};
calculateGravamenRound.rawArgs = true;
const calculateGravamenRoundInteger = (args, math, scope) => {
  return calculateBaseGravamen(args, math, scope, import_math.roundIntegerFunction, true, true);
};
calculateGravamenRoundInteger.rawArgs = true;
const buildMatrixText = import_math.buildMatrixTextFunction;
const concatenate = import_math.concatenateFunction;
const dateHumanize = import_math.dateHumanizeFunction;
const dateReverse = import_math.dateReverseFunction;
const dateCalculateDays = import_math.dateCalculateDaysFunction;
const elementMatrixNumber = (matrix, position) => {
  const cleanMatrix = (0, import_utils.sanitizeNumber)(matrix);
  return (0, import_math.elementMatrixFunction)(import_utils.ARG.SCALAR.NUMBER, cleanMatrix, position);
};
const elementMatrixText = (matrix, position) => {
  const cleanMatrix = (0, import_utils.sanitizeString)(matrix);
  return (0, import_math.elementMatrixFunction)(import_utils.ARG.SCALAR.STRING, cleanMatrix, position);
};
const empty = import_math.emptyFunction;
const floor = import_math.floorFunction;
const leftNumber = import_math.leftNumberFunction;
const leftText = import_math.leftTextFunction;
const logic = import_math.logicFunction;
const maximum = import_math.maximumFunction;
const minimum = import_math.minimumFunction;
const mode = import_math.modeFunction;
const notEmpty = import_math.notEmptyFunction;
const parseName = import_math.parseNameFunction;
const percentage = import_math.percentageFunction;
const rightNumber = import_math.rightNumberFunction;
const rightText = import_math.rightTextFunction;
const round = import_math.roundFunction;
const roundInteger = import_math.roundIntegerFunction;
const sanitize = import_math.sanitizeFunction;
const summatoryMatrix = import_math.summatoryMatrixFunction;
var scalar_default = {
  buildMatrixText,
  calculateGravamen,
  calculateGravamenRound,
  calculateGravamenRoundInteger,
  concatenate,
  dateCalculateDays,
  dateHumanize,
  dateReverse,
  elementMatrixNumber,
  elementMatrixText,
  empty,
  floor,
  leftNumber,
  leftText,
  logic,
  maximum,
  minimum,
  mode,
  notEmpty,
  parseName,
  percentage,
  rightNumber,
  rightText,
  round,
  roundInteger,
  sanitize,
  summatoryMatrix
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  SCALAR_FUNCTIONS,
  SCALAR_FUNCTION_TRANSLATE
});
